import React, { useState, useEffect } from 'react';

// Services
import { billStatuses } from 'services/constants';

// Components
import SelectMultiple from 'components/select-multiple';

// ---------------------------------------------------------------------------------------------- \\
// ------------------------------------- SELECT BILL STATUSES ----------------------------------- \\
// ---------------------------------------------------------------------------------------------- \\

const SelectBillStatuses = ({ statuses, setStatuses }) => {
    const [options, setOptions] = useState([]);

    useEffect(() => {
        setOptions(billStatuses.map(s => ({ label: s.label, value: s.value })));
    }, []);

    return (
        <SelectMultiple
            value={statuses}
            onChange={value => setStatuses(value)}
            options={options}
            placeholder="Statut bon de commande"
        />
    );
};

export default SelectBillStatuses;
